import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Detects CRM subdomain (phcrm.phispano.com) and redirects to /admin
 * This allows workers to access the CRM directly via phcrm.phispano.com
 */
const SubdomainRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname;
    
    // Check if accessing via CRM subdomain
    const isCRMSubdomain = 
      hostname === 'phcrm.phispano.com' || 
      hostname === 'crm.phispano.com' ||
      hostname.startsWith('phcrm.') ||
      hostname.startsWith('crm.');

    // If on CRM subdomain and not already on a PHCRM route, redirect to /phcrm
    if (isCRMSubdomain && !location.pathname.startsWith('/phcrm') && location.pathname !== '/auth') {
      navigate('/phcrm', { replace: true });
    }
  }, [navigate, location.pathname]);

  return null;
};

export default SubdomainRedirect;
